import { ProjectItems, User, UserItems, SocialLinkItems, UserList } from "../../types/Applications";

export const UserProfileData: UserItems[] = [
  {
    iconClass: "envelope",
    text: "Email",
    spanText: "Marekjecno@yahoo.com",
  },
  {
    iconClass: "calendar",
    text: "BOD",
    spanText: "02 January 1988",
  },
];

export const UserAddress: UserItems[] = [
  {
    iconClass: "phone",
    text: "   Contact Us",
    spanText: "India +91 123-456-7890",
  },
  {
    iconClass: "location-arrow",
    text: "   Location",
    spanText: "69 Near School Demo Home",
  },
];

export const UserSocialLinks: SocialLinkItems[] = [
  {
    link: "https://www.facebook.com/",
    icon: "fa fa-facebook",
  },
  {
    link: "https://accounts.google.com/",
    icon: "fa fa-google-plus",
  },
  {
    link: "https://twitter.com/",
    icon: "fa fa-twitter",
  },
  {
    link: "https://www.instagram.com/",
    icon: "fa fa-instagram",
  },
  {
    link: "https://rss.app/",
    icon: "fa fa-rss",
  },
];

export const UserFollowCounts: UserList[] = [
  {
    count: 25869,
    text: "Follower",
    class: "text-md-end border-right",
  },
  {
    count: 659887,
    text: "Following",
    class: "text-md-start",
  },
];

export const CommonUser: UserList[] = [
  {
    listClass: "border-right pe-3",
    icon: "heart",
    text: "  Like",
    count: 2659,
  },
  {
    listClass: "ms-2",
    icon: "comment",
    text: "  Comment",
    count: 569,
  },
];

export const Project: ProjectItems[] = [
  {
    date: "28 May 2024",
    status: "Completed",
    statusClass: "bg-success",
    price: "$56,908",
  },
  {
    date: "12 June 2024",
    status: "On going",
    statusClass: "bg-danger",
    price: "$45,087",
  },
  {
    date: "12 July 2024",
    status: "Pending",
    statusClass: "bg-warning",
    price: "$60,123",
  },
  {
    date: "14 June 2024",
    status: "Pending",
    statusClass: "bg-warning",
    price: "$70,435",
  },
  {
    date: "25 June 2024",
    status: "Completed",
    statusClass: "bg-success",
    price: "$15,987",
  },
];

export const UserLists: User[] = [
  {
    id: 1,
    avatar: "dashboard-8/profile.png",
    icon: "profile-check",
    name: "Brooklyn Simmons",
    email: "@brookly.simmons",
    totalPost: "1,908",
    follower: "34.0k",
    following: "897",
  },
  {
    id: 2,
    avatar: "avtar/3.jpg",
    icon: "profile-check",
    name: "Mark Jecno",
    email: "@mark.jeco",
    totalPost: "875",
    follower: "12.0k",
    following: "1400",
  },
  {
    id: 3,
    avatar: "avtar/11.jpg",
    icon: "profile-check",
    name: "Dev John",
    email: "@john.dev",
    totalPost: "1,274",
    follower: "15.0k",
    following: "1874",
  },
  {
    id: 4,
    avatar: "avtar/16.jpg",
    icon: "profile-check",
    name: "Johan Deo",
    email: "@deo.johan",
    totalPost: "500",
    follower: "8.0k",
    following: "570",
  },
  {
    id: 5,
    avatar: "user/7.jpg",
    icon: "profile-check",
    name: "Douglas Reichel",
    email: "@reichel.douglas",
    totalPost: "460",
    follower: "2k",
    following: "350",
  },
  {
    id: 6,
    avatar: "avtar/4.jpg",
    icon: "profile-check",
    name: "Lisa lillian",
    email: "@lisa.lillian",
    totalPost: "547",
    follower: "3.5k",
    following: "822",
  },
  {
    id: 7,
    avatar: "user/1.jpg",
    icon: "profile-check",
    name: "Olivia rose",
    email: "@rose.olivia",
    totalPost: "868",
    follower: "1k",
    following: "742",
  },
  {
    id: 8,
    avatar: "user/2.png",
    icon: "profile-check",
    name: "Sarah Karen",
    email: "@karen.sarah",
    totalPost: "972",
    follower: "2.5k",
    following: "864",
  },
];
